<template>
<div id="sheet-cheatsheet">
  <modal v-model="show"
         size="lg"
         :header="false"
         :footer="false">
    <div class="row">
      <div class="col-xs-12 col-md-10 col-md-offset-1">
        <div class="text-center">
          <tabs pills v-model="tab" justified>
            <tab title="Navigation">
              <table class="table table-responsive">
                <thead>
                  <tr>
                    <td colspan="3">Entête</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="establishment-name">CHU DE TOURS</span>
                    </td>
                    <td><strong>Établissement</strong></td>
                    <td>
                      Cliquer sur le nom de l'établissement ou sur
                      <btn disabled size="xs">Changer d'établissement</btn>
                      pour changer de surveillance.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="label label-success">BactADI</span>
                    </td>
                    <td>
                      <strong>Modalités</strong>
                    </td>
                    <td>
                      Redirige vers la liste des fiches pour cette modalité.
                      Toutes les modalités de la surveillance sont affichées
                      successivement.
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr >
                    <td colspan="3">
                      Menu principal
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="glyphicon glyphicon-home"></span>
                    </td>
                    <td>
                      <strong>Accueil</strong>
                    </td>
                    <td>
                      Résumé de la surveillance : modalités, nombre de fiches
                      saisies, etc.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="glyphicon glyphicon-user"></span>
                    </td>
                    <td>
                      <strong>Membres</strong>
                    </td>
                    <td>
                      Permet de définir les co-référent.e.s et les
                      opérateur.rice.s de saisie pour cette surveillance.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="glyphicon glyphicon-list-alt"></span>
                    </td>
                    <td>
                      <strong>Fiche Établissement</strong>
                    </td>
                    <td>
                      Permet de remplir les 3 tableaux de la fiche établissement.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="glyphicon glyphicon-cog"></span>
                    </td>
                    <td>
                      <strong>Menu Options</strong>
                    </td>
                    <td>
                      Liste toutes les options disponibles pour l'espace
                      surveillance. Chaque option peut être activée
                      (<span class="glyphicon glyphicon-ok text-success" />)
                      ou désactivée (<span class="glyphicon glyphicon-remove text-danger" />)
                      en cliquant sur la ligne correspondante. Une petite explication
                      complémentaire s'affiche également lorsque la souris passe sur
                      une option.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="glyphicon glyphicon-question-sign"></span>
                    </td>
                    <td>
                      <strong>Aide</strong>
                    </td>
                    <td>
                      Affiche cette fenêtre.
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr class="primary">
                    <td colspan="3">Fiches</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="label label-success">BactADI</span>
                    </td>
                    <td>
                      <strong>Modalité</strong>
                    </td>
                    <td>
                      Indique à quelle modalité appartient la fiche et/ou
                      la liste affichée à l'écran.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="glyphicon glyphicon-pencil"></span>
                    </td>
                    <td>
                      <strong>Vue Fiche</strong>
                    </td>
                    <td>
                      Permet d'alterner entre la <strong>vue fiche</strong>
                      permettant l'édition de la fiche en cours et la
                      <strong>vue liste</strong> contenant la liste des
                      fiches déjà remplies pour la modalité en cours.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="glyphicon glyphicon-list"></span>
                    </td>
                    <td>
                      <strong>Vue Liste</strong>
                    </td>
                    <td>
                      Permet d'alterner entre la <strong>vue fiche</strong>
                      et la <strong>vue liste</strong>.
                    </td>
                  </tr>

                </tbody>
              </table>
            </tab>
            <tab title="Vue Fiche">
              <div class="demo-container">
                <img class="img-responsive"
                     :src="require('@/assets/cheatsheet/cheatsheet.jpg')" />
              </div>
            </tab>
            <tab title="Raccourcis clavier">
              <table class="table table-responsive">
                <thead>
                  <tr >
                    <td colspan="3">
                      Vue Fiche
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="k in sheetKeys"
                      :key="`cheatsheet-key-${k.action}`">
                    <td v-html="k.keys">
                    </td>
                    <td v-html="k.text">
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr >
                    <td colspan="3">
                      Vue Liste
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="k in listKeys"
                      :key="`cheatsheet-key-${k.action}`">
                    <td v-html="k.keys">
                    </td>
                    <td v-html="k.text">
                    </td>
                  </tr>
                </tbody>
              </table>
            </tab>
          </tabs>
        </div>
      </div>
    </div>
    <div class="text-center">
      <btn v-if="tab !== 2" size="lg"
           type="warning" @click.stop="tab++">
        Suivant
      </btn>
      <btn v-else type="success" @click.stop="show = false" size="lg">
        <strong>J'ai compris</strong>
      </btn>
    </div>
  </modal>
</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'sheet-add-cheatsheet',
  props: {
    value: Boolean
  },

  computed: {
    ...mapGetters({
      shown: 'user/firstCheat'
    })
  },

  data: function () {
    return {
      show: this.value,
      tab: 0,
      sheetKeys: [
        {
          action: 'commit',
          keys: `<span class="key">Entrée ⏎</span>`,
          text: `Valide la valeur en cours de modification et passe au champ suivant.`
        },
        {
          action: 'next',
          keys: `<span class="key">↹ Tab</span>`,
          text: `Passe au champ suivant <strong>sans valider</strong> la saisie en cours.`
        },
        {
          action: 'back',
          keys: `
<span class="key">⇧ Shift</span>+<span class="key">↹ Tab</span>`,
          text: `Revient au champ précédent <strong>sans valider</strong> la saisie en cours.`
        },
        {
          action: 'save',
          keys: `<span class="key">F3</span>`,
          text: `Sauvegarde la fiche en cours.`
        },
        {
          action: 'new',
          keys: `<span class="key">F4</span>`,
          text: `Créé une nouvelle fiche (uniquement possible depuis une fiche sauvegardée).`
        },
        {
          action: 'previousSheet',
          keys: `<span class="key">F8</span>`,
          text: `Passe à la fiche précédente du <strong>même statut</strong>
(<strong class="text-primary">en cours de saisie</strong> ou
<strong class="text-success">validée</strong>).`
        },
        {
          action: 'nextSheet',
          keys: `<span class="key">F9</span>`,
          text: `Passe à la fiche suivante du <strong>même statut</strong>
(<strong class="text-primary">en cours de saisie</strong> ou
<strong class="text-success">validée</strong>).`
        },
        {
          action: 'listVue',
          keys: `<span class="key">F12</span>`,
          text: `Bascule en <strong>vue liste</strong>.`
        }
      ],
      listKeys: [
        {
          action: 'new',
          keys: `<span class="key">F4</span>`,
          text: `Créé une nouvelle fiche (uniquement possible depuis une fiche sauvegardée).`
        },
        {
          action: 'sheetVue',
          keys: `<span class="key">F12</span>`,
          text: `Bascule en <strong>vue fiche</strong>.`
        }
      ]
    }
  },

  watch: {
    value: function () {
      this.show = this.value
    },

    show: function (value, old) {
      if (!value && old && !this.shown) {
        this.$store.dispatch('user/firstCheat', 2)
      }
      this.$emit('input', this.show)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~variables';

#sheet-cheatsheet {
    h5 {
        font-weight: bold;
    }

    .tab-pane {
        padding-top: 2rem;
        min-height: 20rem;
    }

    .demo-container {
        img {
            margin: auto;
        }
    }

    thead {
        tr {
            td {
                font-size: 110%;
                color: white;
                background-color: @base;
                border: 0px;
            }
        }
    }
}
</style>
